import React, { Component } from 'react';
import PropTypes from 'prop-types';
import branch from 'client/core/branch';

import {
  SR_API_ACTION_GET_APARTMENT_BITLY_LINK,
} from 'api/actionTypes';

import {
  SCREEN_ID_LOCATOR_TOURS_SUCCESS_PAGE,
} from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import postWithState from 'client/actions/postWithState';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrLocatorToursNavbar from 'client/components/SrLocatorToursNavbar';

@withTransitionHook
@withScreenId(SCREEN_ID_LOCATOR_TOURS_SUCCESS_PAGE)
@withScrollToTop
@branch()
class LocatorToursSuccessPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Locator Tours',
  })

  static propTypes = {
    match: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      applyLink: '',
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_GET_APARTMENT_BITLY_LINK,
      payload: {
        apartmentId: parseInt(match.params.apartmentId, 10),
      },
    }).then((bitlyLink) => {
      this.setState({
        applyLink: bitlyLink,
      });
    });

  }

  render() {
    const { applyLink } = this.state;
    return (
      <div className='width-90'>
        <SrLocatorToursNavbar
          withLogo
          withTopPadding
          align='center'
          redirectTo='/locatortours'
        />
        <SrBox textAlign='center'>
          <img width='217' height='126' src='/images/illustration-confirm-thumbs-up.svg' alt='Success' />
        </SrBox>
        <SrText
          display='block'
          align='center'
          size='40'
          weight='bolder'
          leading='45'
          font='greycliff'
          paddingTop='11px'
        >
          Successfully Submitted!
        </SrText>
        <SrBox
          padding='13px 30px'
        >
          <SrText
            display='block'
            align='center'
            size='large'
            weight='medium'
            font='greycliff'
            spacing='0'
          >
            Thank you very much for showing these units to your client & submitting their feedback.
            <br />
            <br />
            To apply, please send your client this link
            <br />
            <SrText color='blue300' size='large' weight='medium'>
              {applyLink}
            </SrText>
            <br />
            <br />
            We received your digital guest card!
            <br />
            Thanks again 👋
          </SrText>
        </SrBox>
      </div>
    );
  }
}

LocatorToursSuccessPage.displayName = 'LocatorToursSuccessPage';

export default LocatorToursSuccessPage;
